import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#17469E',
        secondary: '#1E3561',
        variantPrimary: '#9DF0FF',
        variantSecondary: '#01BBDE',
        myColor: '#D9E1ED',
        text: '#FFFFFF',
        error: '#DB2F2F',
        background: '#EDEDED',
        surface: '#FFFFFF',
      },
      dark: {
        primary: '#17469E',
        secondary: '#1E3561',
        text: '#FFFFFF',
        error: '#DB2F2F',
        background: '#EDEDED',
        surface: '#FFFFFF',
      },
    },
  },
});
